export const extrapayFlowDictES = {
  extrapayFlowTitle: "Extrapay",
  extrapayFlowProgram: "EXTRAPAY | PROGRAMA DE PUNTOS",
  extrapayFlowBannerTitle: "Tus compras abren nuevas posibilidades.",
  extrapayFlowBannerSubtitle:
    "Acumula puntos en las compras. Cada 10 compras aprobadas, tus puntos se convierten en EXC.",
  extrapayFlowOpen: "Acceder a Extrapay",
  extrapayFlowCyclePoints: "Puntos del ciclo",
  extrapayFlowPointsUnit: "puntos",
  extrapayFlowPointsAccumulated: "Acumulados en las compras de este ciclo",
  extrapayFlowOrdersProgress: "{current} de {total} compras",
  extrapayFlowCycleLabel: "Ciclo {cycle}",
  extrapayFlowOnePurchaseLeft: "Falta 1 compra para concluir el ciclo.",
  extrapayFlowPurchasesLeft: "Faltan {count} compras para concluir el ciclo.",
  extrapayFlowCycleComplete: "Ciclo completo. La conversión en EXC se hace automáticamente.",
  extrapayFlowAccumulatedRate: "Tasa de conversión acumulada",
  extrapayFlowRateContinues: "Sigue acumulada en los próximos ciclos",
  extrapayFlowPlatformBalance: "SALDO EXC EN LA PLATAFORMA",
  extrapayFlowAvailableExternal: "Disponible para envío a tu cartera externa.",
  extrapayFlowRequestWithdraw: "Solicitar retiro",
  extrapayFlowLoadError: "No fue posible cargar Extrapay.",
  extrapayFlowRetry: "Intentar de nuevo",
  extrapayFlowPageSubtitle: "Sigue tus puntos, EXC y solicitudes de retiro.",
  extrapayFlowPointsTitle: "PUNTOS EXTRAPAY",
  extrapayFlowCanRequest: "Puedes solicitar {amount} EXC para tu cartera externa.",
  extrapayFlowRateNotice:
    "Tu tasa de conversión acumulada es {rate}. Sigue acumulada en los próximos ciclos.",
  extrapayFlowUnderstandRate: "Entender la tasa",
  extrapayFlowTabPoints: "Puntos",
  extrapayFlowTabExc: "EXC",
  extrapayFlowTabWithdrawals: "Retiros",
  extrapayFlowOrigin: "Origen",
  extrapayFlowDate: "Fecha",
  extrapayFlowCycle: "Ciclo",
  extrapayFlowPoints: "Puntos",
  extrapayFlowViewDetails: "Ver detalles",
  extrapayFlowPurchaseOrigin: "Compra #{id}",
  extrapayFlowMovement: "Movimiento",
  extrapayFlowRequest: "Solicitud",
  extrapayFlowSituation: "Situación",
  extrapayFlowPointsEmpty: "No se encontraron compras aprobadas.",
  extrapayFlowExcEmpty: "Las conversiones de puntos en EXC aparecerán aquí cuando se complete un ciclo.",
  extrapayFlowWithdrawalsEmpty: "Todavía no solicitaste retiros de EXC.",
  extrapayFlowPreviousCyclesEmpty: "Los ciclos ya convertidos aparecerán aquí.",
  extrapayFlowStatusRequested: "Solicitado",
  extrapayFlowStatusAwaiting: "Esperando transferencia",
  extrapayFlowStatusConfirmed: "Confirmado",
  extrapayFlowStatusConverted: "Convertido",
  extrapayFlowStatusNotConverted: "No convertido",
  extrapayFlowStatusInProgress: "En curso",
  extrapayFlowStatusAccumulating: "Acumulando compras",
  extrapayFlowKnowTitle: "Conoce Extrapay",
  extrapayFlowKnowSubtitle: "Entiende cómo tus compras generan puntos y saldo EXC en la plataforma.",
  extrapayFlowKnowProgram: "PROGRAMA DE PUNTOS",
  extrapayFlowKnowHeading: "Cómo funciona Extrapay",
  extrapayFlowKnowIntro:
    "Extrapay registra puntos en las compras con pago aprobado. Cada 10 compras, esos puntos se convierten en Extracoin (EXC), que queda en tu saldo dentro de la plataforma.",
  extrapayFlowStepPurchase: "COMPRA APROBADA",
  extrapayFlowStepPurchaseNote: "después de descuentos · sin envío",
  extrapayFlowStepPurchasePoints: "+50 puntos",
  extrapayFlowStep1Label: "ETAPA 1 · PUNTOS",
  extrapayFlowStep1Title: "Los puntos entran después del pago",
  extrapayFlowStep1Body:
    "Recibes puntos equivalentes al 50% del valor de la compra después de descuentos. Por ejemplo, una compra de € 100, sin envío, genera 50 puntos.",
  extrapayFlowStepCycle: "TU CICLO DE COMPRAS",
  extrapayFlowStepCycleDone: "10 compras aprobadas",
  extrapayFlowStep2Label: "ETAPA 2 · CICLO",
  extrapayFlowStep2Title: "Cada ciclo reúne 10 compras",
  extrapayFlowStep2Body:
    "Cada compra con pago aprobado cuenta como una etapa. En Extrapay consultas los puntos acumulados y cuántas compras faltan para completar el ciclo.",
  extrapayFlowStepBalance: "SALDO EN LA PLATAFORMA",
  extrapayFlowStepBalanceNote: "Crédito después de la conversión",
  extrapayFlowStep3Label: "ETAPA 3 · CONVERSIÓN",
  extrapayFlowStep3Title: "Los puntos se convierten en EXC",
  extrapayFlowStep3Body:
    "En la décima compra, el sistema multiplica los puntos del ciclo por tu tasa de conversión acumulada. El resultado se acredita en EXC en el saldo de la plataforma.",
  extrapayFlowAfterConversionTitle: "Qué cambia después de la conversión",
  extrapayFlowAfterConversionBody:
    "Cuando el crédito en EXC se completa, los puntos del ciclo y el contador de compras vuelven a cero. La tasa de conversión sigue acumulada y se usará en los próximos ciclos.",
  extrapayFlowBalanceSection: "SALDO Y RETIRO",
  extrapayFlowWhereTitle: "Dónde quedan los EXC recibidos",
  extrapayFlowWhereBody:
    "EXC es la sigla de Extracoin. Después de la conversión, el valor queda registrado en la plataforma. Para recibirlo en una cartera cripto externa, debes solicitar un retiro.",
  extrapayFlowOnPlatform: "En la plataforma",
  extrapayFlowYourExcBalance: "Tu saldo EXC",
  extrapayFlowOnExternalWallet: "En la cartera externa",
  extrapayFlowSameExcAmount: "La misma cantidad de EXC",
  extrapayFlowWithdrawPath:
    "Al solicitar el retiro, indica la dirección de la cartera y el valor. El valor se descuenta del saldo en la plataforma al confirmar. Después, el equipo envía la misma cantidad de EXC a la dirección indicada.",
  extrapayFlowFaqTitle: "Detalles sobre el cálculo y el retiro",
  extrapayFlowFaqSubtitle: "Selecciona una pregunta para consultar la explicación.",
  extrapayFlowFaqWhen: "¿Cuánto EXC voy a recibir?",
  extrapayFlowFaqWhenAnswer:
    "La cantidad de EXC depende de dos valores: los puntos acumulados en el ciclo y la tasa de conversión acumulada. Por eso, ciclos diferentes pueden generar cantidades diferentes de EXC.",
  extrapayFlowFaqWhenExampleLabel: "UN EJEMPLO",
  extrapayFlowFaqWhenExampleFormula: "500 puntos × 0,00070 de tasa = 0,35 EXC",
  extrapayFlowFaqWhenExampleNote:
    "En este ejemplo, son 10 compras de € 100 después de descuentos, sin envío, usando 18 Extracredits en cada compra y empezando con la tasa en cero. Otras compras y tasas pueden generar valores diferentes.",
  extrapayFlowFaqRate: "¿Cómo aumenta mi tasa de conversión?",
  extrapayFlowFaqRateAnswer:
    "Cada compra suma 3 puntos para el cálculo de la tasa cuando no hay envío, o 6 cuando hay envío. La cantidad de Extracredit utilizada también se suma.",
  extrapayFlowFaqRateAnswer2:
    "Esta puntuación sirve solo para calcular la tasa; no entra en el saldo de puntos del ciclo. La tasa es el número usado para convertir los puntos en EXC, no una tarifa cobrada. El sistema calcula y muestra ese número en Extrapay.",
  extrapayFlowFaqRateCalcTitle: "Cálculo completo",
  extrapayFlowFaqRateCalcLine1: "Tasa acumulada = puntuación acumulada para la tasa ÷ 3 × 0,00001.",
  extrapayFlowFaqRateCalcLine2:
    "En el ejemplo: 10 × (3 + 18) = 210. La tasa es 210 ÷ 3 × 0,00001 = 0,00070. Después, 500 puntos × 0,00070 = 0,35 EXC en el saldo de la plataforma.",
  extrapayFlowFaqRateCalcLine3:
    "Los puntos del ciclo corresponden al 50% del valor de la compra después de descuentos. La tasa no tiene límite ni vencimiento definidos.",
  extrapayFlowFaqWallet: "¿Necesito una cartera cripto para empezar?",
  extrapayFlowFaqWalletAnswer:
    "No. Tus EXC quedan en el saldo de la plataforma. Solo necesitas indicar la dirección de una cartera compatible con la red Extracoin cuando quieras solicitar un retiro.",
  extrapayFlowFaqWalletAnswer2:
    "El crédito en Extrapay no es una transferencia a la cartera externa. Esa transferencia ocurre después de la solicitud y la hace el equipo.",
  extrapayFlowKnowCtaTitle: "Consulta tu ciclo y tu saldo",
  extrapayFlowKnowCtaBody:
    "En Extrapay encuentras los puntos acumulados, el número de compras y los EXC disponibles.",
  extrapayFlowKnowCta: "Consultar mi Extrapay",
  extrapayFlowWithdrawTitle: "Retiro de tokens",
  extrapayFlowWithdrawSubtitle: "Consulta el saldo y sigue tus solicitudes.",
  extrapayFlowWalletAddress: "Dirección de la cartera Extracoin",
  extrapayFlowWalletAddressHint: "Copia la dirección de recepción de tu cartera en la red Extracoin.",
  extrapayFlowWithdrawAmount: "Valor del retiro en EXC",
  extrapayFlowAvailableBalance: "Saldo disponible en la plataforma: {amount} EXC.",
  extrapayFlowReviewWithdraw: "Revisar retiro",
  extrapayFlowHowYouReceive: "Cómo lo recibirás",
  extrapayFlowHowYouReceiveBody:
    "El Extracoin se enviará a la cartera que indiques. Comprueba que la dirección te pertenece y está en la red Extracoin.",
  extrapayFlowHowYouReceiveDebit:
    "Al confirmar, el valor se descuenta de tu saldo EXC en la plataforma. El equipo hará la transferencia después.",
  extrapayFlowHowYouReceivePartial:
    "Puedes solicitar una parte del saldo y seguir cada pedido en “Mis retiros”.",
  extrapayFlowDebitNotice: "El valor solicitado se descontará de tu saldo EXC en la plataforma.",
  extrapayFlowAddressRequired: "Indica la dirección de la cartera.",
  extrapayFlowAmountRequired: "Indica un valor mayor que cero.",
  extrapayFlowAmountAboveBalance: "El valor no puede ser mayor que el saldo disponible.",
  extrapayFlowConfirmTitle: "Confirma tu retiro",
  extrapayFlowConfirmSubtitle: "Revisa la dirección y el valor antes de confirmar.",
  extrapayFlowYouReceive: "Recibirás",
  extrapayFlowNetwork: "Red",
  extrapayFlowNetworkName: "Extracoin",
  extrapayFlowDestination: "Dirección de destino",
  extrapayFlowPlatformDebit: "Descuento del saldo en la plataforma",
  extrapayFlowBalanceAfter: "Saldo en la plataforma después de la solicitud",
  extrapayFlowConfirmCheck: "Revisé la dirección de mi cartera y el valor del retiro.",
  extrapayFlowConfirmNote:
    "Al confirmar, el valor se descontará de tu saldo EXC en la plataforma. El envío a la cartera externa se hará después.",
  extrapayFlowConfirmAction: "Confirmar retiro",
  extrapayFlowEditValues: "Editar dirección o valor",
  extrapayFlowSuccessTitle: "Solicitud registrada",
  extrapayFlowSuccessSubtitle: "El saldo se actualizó. Sigue la transferencia en el historial.",
  extrapayFlowAvailableBalanceLabel: "Saldo disponible",
  extrapayFlowAddress: "Dirección",
  extrapayFlowSuccessNote:
    "El equipo hará la transferencia a tu cartera. Sigue la actualización en “Mis retiros”.",
  extrapayFlowTrackWithdraw: "Seguir retiro",
  extrapayFlowMyWithdrawals: "Mis retiros",
  extrapayFlowWithdrawalsCrumb: "Retiros",
  extrapayFlowDetailsCrumb: "Detalles",
  extrapayFlowCycleCrumb: "Detalles del ciclo",
  extrapayFlowWithdrawDetailsTitle: "Detalles del retiro {id}",
  extrapayFlowWithdrawDetailsSubtitle:
    "Tu pedido quedó registrado y el valor se descontó del saldo EXC en la plataforma.",
  extrapayFlowRequestDate: "Fecha de la solicitud",
  extrapayFlowUser: "Usuario",
  extrapayFlowWithdrawValue: "Valor del retiro",
  extrapayFlowInformedAddress: "Dirección indicada",
  extrapayFlowBackToWithdrawals: "Volver a los retiros",
  extrapayFlowWithdrawNotFound: "No fue posible encontrar esta solicitud.",
  extrapayFlowCycleSubtitle: "Cada 10 compras aprobadas, tus puntos se convierten en EXC.",
  extrapayFlowPurchases: "Compras",
  extrapayFlowAccumulatedFee: "Tasa acumulada",
  extrapayFlowPointsToConvert: "Puntos a convertir",
  extrapayFlowCyclePointsTitle: "Puntos del ciclo",
  extrapayFlowViewPoints: "Ver puntos",
  extrapayFlowPreviousCycles: "Ciclos anteriores y operaciones",
  extrapayFlowOperation: "Operación",
  extrapayFlowBackToExtrapay: "Volver a Extrapay",
  extrapayFlowConversionTitle: "Conversión del Ciclo {cycle}",
  extrapayFlowConversionFallback: "Conversión",
  extrapayFlowUnavailable: "—",
  extrapayFlowBasicData: "Datos básicos",
  extrapayFlowReference: "Referencia",
  extrapayFlowQuantity: "Cantidad",
  extrapayFlowViewFullConversion: "Ver conversión completa",
  extrapayFlowExcAmount: "{amount} EXC",
  extrapayFlowSignedExc: "+{amount} EXC",
  extrapayFlowSignedPoints: "+{amount}",
  extrapayFlowPurchasePointsTitle: "Puntos de la compra #{id}",
  extrapayFlowPurchasePointsSubtitle: "Consulta de dónde vinieron los puntos de este movimiento.",
  extrapayFlowAmountAfterDiscount: "Valor después del descuento",
  extrapayFlowPointsPercent: "Porcentaje en puntos",
  extrapayFlowPointsPercentValue: "50%",
  extrapayFlowPointsReceived: "Puntos recibidos",
  extrapayFlowPurchasePointsNote:
    "Estos puntos quedan en el saldo del ciclo hasta la conversión después de 10 compras.",
  extrapayFlowOtpInvalid:
    "Código de verificación inválido o expirado. Revisa tu correo o solicita un nuevo código.",
};
